import React from 'react';
import { FAQLinksModule as FrodorFAQLinksModule } from '@spotify-internal/frodor-modules';
import { ModuleType } from '../types';
import { useT } from '@spotify-internal/i18n-core';

const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'https://artists.spotify.com';
};

export type FAQType = {
  question: string;
  urlSlug: string;
  answer: string;
  id: string;
  contentType: string;
};

export type FAQLinksModuleType = ModuleType & {
  supertext?: string;
  headline?: string;
  faqs?: FAQType[];
  ctaButton?: {
    ctaLink: string;
    ctaText: string;
    title: string;
    openInNewTab: boolean;
  };
};

export const FAQLinksModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  FAQLinksModuleType
>(({ supertext = '', headline = '', faqs = [], ctaButton, ...rest }, ref) => {
  const t = useT();
  const baseUrl = getBaseUrl();

  // Transform FAQs to use absolute URLs
  const transformedFaqs = faqs.map(faq => ({
    question: faq.question,
    href: `${baseUrl}/help/article/${faq.urlSlug}`,
    id: faq.id,
  }));

  // Use provided ctaButton or fallback to default
  const finalCtaButton = ctaButton || {
    ctaLink: `${baseUrl}/help`,
    ctaText: t(
      'FRODOR_SEE_ALL_FAQS',
      'See all FAQs',
      'link to the help center containing frequently asked questions',
    ),
    title: t(
      'FRODOR_SEE_ALL_FAQS',
      'See all FAQs',
      'link to the help center containing frequently asked questions',
    ),
    openInNewTab: false,
  };

  return (
    <FrodorFAQLinksModule
      {...rest}
      ref={ref}
      supertext={supertext}
      headline={headline}
      faqs={transformedFaqs}
      ctaButton={finalCtaButton}
    />
  );
});
